// ~/plugins/popupHandler.ts
export default defineNuxtPlugin(nuxtApp => {
  const registeredListeners: {
    [popupId: string]: {
      listener: (event: MouseEvent) => void
    }
  } = {}

  const addEventListener = ({
    popupId,
    listener,
  }: {
    popupId: string
    listener: (event: MouseEvent) => void
  }) => {
    if (registeredListeners[popupId]) return
    registeredListeners[popupId] = { listener }
    document.addEventListener('mousedown', listener, { capture: true })
  }

  const removeEventListener = (popupId: string) => {
    if (registeredListeners[popupId]) {
      document.removeEventListener(
        'mousedown',
        registeredListeners[popupId].listener,
        { capture: true }
      )

      delete registeredListeners[popupId]
    }
  }

  const isPopupOpen = (popupId: string) => {
    const hasListener = registeredListeners[popupId] != null
    const popupElement = document.getElementById(popupId)
    const contentEl = popupElement?.querySelector(
      '.popup-content'
    ) as HTMLElement
    const isVisible = contentEl?.style.display === 'block'
    if (hasListener) {
      if (isVisible) {
        return true
      } else {
        removeEventListener(popupId)
        return false
      }
    }
    return false
  }

  const openPopup = (popupId: string) => {
    const popupElement = document.getElementById(popupId)
    const contentEl = popupElement?.querySelector(
      '.popup-content'
    ) as HTMLElement

    if (!contentEl) return
    contentEl.style.display = 'block'

    const eventListener = (event: MouseEvent) => {
      const popupEl = document.getElementById(popupId)

      const isClickOnPopup = popupEl?.contains(event.target as Node)

      if (!isClickOnPopup && contentEl) {
        contentEl.style.display = 'none'
        removeEventListener(popupId)
      }
    }
    addEventListener({
      popupId,
      listener: eventListener,
    })
  }

  const closePopup = (popupId: string) => {
    const popupElement = document.getElementById(popupId)
    const popupContent = popupElement?.querySelector(
      '.popup-content'
    ) as HTMLElement
    if (!popupContent) return
    popupContent.style.display = 'none'
    removeEventListener(popupId)
  }

  const imageMouseDown = () => {
    const listeners = Object.values(registeredListeners).map(
      listener => listener.listener
    )
    listeners.forEach(listener => {
      listener(new MouseEvent('mousedown'))
    })
  }

  nuxtApp.provide('popupHandler', {
    isPopupOpen,
    openPopup,
    closePopup,
    imageMouseDown,
  })
})
